"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_merge_1 = __importDefault(require("lodash.merge"));
/**
 *
 * @param preconfigs
 * @param options
 * @returns Merges preconfigs with options
 */
var setPreconfigs = function (preconfigs, options) {
    var optionsPreconfigs = {
        appearance: options.appearance,
        palette: options.palette,
        background: options.background,
        border: options.border,
        padding: options.padding,
        radius: options.radius,
        shadow: options.shadow,
    };
    return (0, lodash_merge_1.default)(preconfigs, optionsPreconfigs);
};
exports.default = setPreconfigs;
